module.exports = __webpack_public_path__ + "img/thumb_18.3d76f0ac.jpg";